<template>
    <div style="width:90%;margin:20px auto;display:block;">
        <v-layout row justify-center>
        <v-flex xs12 md7>
          <v-card flat style="width:90%;margin:0 auto;display:block;">
                        <v-card-text>

                          <p style="text-align:center;text-transform: uppercase;font-size:25px;
                          font-weight:600;line-height:35px;
                          ">
                            Towers/Power & Conduit
                          </p>

                    <p style="font-weight:500;
                        font-size:20px;padding-top:30px;line-height : 35px;text-align: justify
                        ">
                        Many companies use several different types of 
                        grounding techniques and surge protectors to help 
                        reduce the chances of electrical damage to their 
                        equipment. However, when cables are directly connected 
                        to structures it can greatly increases the chances for 
                        electrical surge damage to the equipment.
                    </p>
                    <p style="font-weight:500;
                        font-size:20px;padding-top:30px;line-height : 35px;text-align: justify
                        ">
                        We used a <strong>Pipe Me In conduit</strong> to conduct a test on a outdoor 
                        Cat6 and Power cables to see how much voltage could be transfer 
                        from the jacket of the cable over to each copper wire inside the 
                        outdoor Cat6 and power cables. The test was conducted using 124 
                        Volts AC, 6 ft long cables and a FLUKE 107 Multimeter.

                    </p>
                        </v-card-text>
                    </v-card>
        </v-flex>
        <v-flex xs12 md5>
          <v-img src="https://pipemein.com/img/nuevaS.jpg" style="margin:0 auto;display:block;"
           height="500" width="500"></v-img>
        </v-flex>
      </v-layout>


    <div style="margin-top:50px;">
      <v-container>
         <v-card flat style="width:90%;margin:0 auto;display:block;">
                        <v-card-text>
                    <p style="font-weight:500;
                        font-size:20px;padding-top:30px;line-height : 35px;text-align: justify
                        ">
                        When the power was on, the multimeter show 16.86 volts 
                        transfer through the jacket of the Cat6 cable to each 
                        one of the copper cables. On the power cables the 
                        multimeter show 34.67 volts.  In a split of a second 
                        this type of power surge can damage equipment. 
                        Specially when higher voltages are involved. 
                    </p>
                    <p style="font-weight:500;
                        font-size:20px;padding-top:30px;line-height : 35px;text-align: justify
                        ">
                        When the Cat6 cable was inside the conduit the multimeter show (0.210 volts.)
                        <strong>Pipe Me In conduit</strong> is rated to withstand 50,000 volts. <br><br>
                        Using our unique cable management system on towers, building, tunnels and more; 
                        will help save companies time, money and effort. 


                    </p>
                        </v-card-text>
                    </v-card>


                    <v-layout row justify-center class="hidden-md-and-down">
                     <v-flex md3>
                       <v-img src="https://pipemein.com/img/teste1.4fccaeae.jpg"></v-img>
                     </v-flex>
                     <v-flex md3 class="mx-5">
                       <v-img src="https://pipemein.com/img/teste2.000c3f8a.jpg"></v-img>
                     </v-flex>
                     <v-flex md3>
                       <v-img src="https://pipemein.com/img/test3.f20e4872.jpg"></v-img>
                     </v-flex>
                    </v-layout>
                    <v-carousel class="hidden-md-and-up" :show-arrows="false">
                    <v-carousel-item
                      v-for="(item,i) in slides"
                      :key="i"
                      :src="item.src"
                      reverse-transition="fade-transition"
                      transition="fade-transition"
                    ></v-carousel-item>
                  </v-carousel>
      </v-container>
    </div>

    <!--<video src="https://pipemein.com/videos/IMG_3849.MOV"
         style="margin:0 auto;display:block;" controls
        loop ></video>-->

        <v-layout row justify-center class="mt-3 mb-3">
                <v-flex xs12 md6 class="my-2">
                    <div style="border:soldi 1px #000;width:90%;margin:0 auto;display:block;">
                        <video 
                        style="border:soldi 1px #000"
                        height="576" controls width="100%">

                    <source src="https://pipemein.com/videos/tiktok2.mp4"
                            type="video/mp4">
                </video>
                    </div>
                </v-flex>
                <v-flex xs12 md6 class="my-2">
                    <div style="width:90%;margin:0 auto;display:block;">
                        <video 
                        style="border:soldi 1px #000"
                        height="576" controls width="100%">

                    <source src="https://pipemein.com/videos/tiktok3.mp4"
                            type="video/mp4">
                </video>
                    </div>
                </v-flex>
            </v-layout>

        <p style="text-align:center;color:black;font-style:italic;font-size:10px;padding:20px 0 20px 0;">
          Power test is subject to change depending on the cables, testers, power and environment.
        </p>

        <div style="margin:100px auto;display:block;">

                        <v-layout row justify-center>
                            <v-flex xs12 md6>

                                <div style="width:95%;margin:0 auto;display:block;">
                                    <p style="font-weight:500;
                                        font-size:20px;padding-top:30px;line-height : 35px;text-align: justify
                                        ">
                                        Armor cables can provide an extra layer of protection from electrical discharge as long as proper grounding techniques are followed. However, when taking a look at the resistance of the cable itself for the test that we performed using 124 volts AC. The Cat5 armor jacket was passing 28.46 volts and the Cat5 copper cables was passing 15.28 volts. When the armor cables were inside the conduit there was 0 additional voltage increase to the Cat5 armor jacket or cables.
                                    
                                    <br><br>
                                    This means that our conduit adds an extra layer of protection to the cables from the elements! 


                                    
                                    </p>
                                </div>

                            </v-flex>
                            <v-flex xs12 md6>

                                <v-carousel :show-arrows="false">
                                    <v-carousel-item
                                    v-for="(item,i) in items"
                                    :key="i"
                                    :src="item.src"
                                    ></v-carousel-item>
                                </v-carousel>

                            </v-flex>
                        </v-layout> 

                    </div>

    </div>
</template>



<script>
export default {
    data(){
        return {
          items: [
          {
            src: 'https://pipemein.com/img/img_cable_0.jpg',
          },
          {
            src: 'https://pipemein.com/img/img_cable_1.jpg',
          },
          {
            src: 'https://pipemein.com/img/img_cable_2.jpg',
          }
        ],
          slides:[
            {
              src: 'https://pipemein.com/img/teste1.4fccaeae.jpg'
            },
            {
              src: 'https://pipemein.com/img/teste2.000c3f8a.jpg'
            },
            {
              src: 'https://pipemein.com/img/test3.f20e4872.jpg'
            }
          ]
        }
    }
}
</script>